<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                        <v-flex >Add Module Topic</v-flex>
                        <v-btn icon @click="CloseDialog">
                            <v-icon color="text--secondary">close</v-icon>
                        </v-btn>
                    </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>
                            <v-select item-value='Course_Id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course " @change="GetCourseSectionList">
                                <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Course_Title }}
                                  </template>
                                  <template slot='item' slot-scope='{ item }'>
                                        {{ item.Course_Title }}    
                                  </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedModule" :items="GetSectionList" label="Select Module">
                                  <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Section_Title }}
                                  </template>
                                  <template slot='item' slot-scope='{ item }'>
                                        {{ item.Section_Title }}    
                                  </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-flex>
                                <v-text-field label="Module Topic Title" v-model="Topic_Title"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Module Topic Start Time (Eg : 00:00 )" v-model="Topic_Start_Time"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Module Topic End Time (Eg : 10:30 )" v-model="Topic_End_Time"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" @click="SubmitTopic">Submit Module Details</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>

export default {
    props: ['dialog'],
    data(){
        return {

            SelectedCourseDetail    : {},
            SelectedModule          : {},
            Topic_Title             : "",
            Topic_Start_Time        : "",
            Topic_End_Time          : "",
            Current_Course_Details  : {},
            Online                  : false
        }
    },
    computed:{
        GetCourseDetailList(){

            return this.$store.getters.GetCourseDetailsList
        },
        GetSectionList(){

            return  this.$store.getters.GetCourseSection
        }
    },
    methods:{
        CloseDialog(){
            this.$emit('close')
        },
        GetCourseSectionList(){

            let data = {}
            data["Course_Id"] = this.SelectedCourseDetail['_id']
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/getsections`,data)
                        .then(response =>{

                            if(response["data"]["response"]){

                                this.$store.commit('SetCourseSection',response["data"]["response"]["Course_Curriculam"])
                                return this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getcoursedetails`,data)

                            }else{

                                this.$store.commit('SetCourseSection',null)
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Add Course Sections","Color":"red","Close": false });

                            }
                             
                        })
                        .then(response =>{

                            this.Current_Course_Details = response['data']['response']
                            this.Online = this.Current_Course_Details.Course_Types.includes('Online')
                                
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        SubmitTopic(){

            let Section = {}
            Section["Course_Id"]          = this.SelectedCourseDetail['_id']
            Section["Section_Id"]         = this.SelectedModule["Section_Id"]
            Section['Topic_Start_Time']   = this.Topic_Start_Time
            Section["Topic_End_Time"]     = this.Topic_End_Time
            Section["Topic_Title"]        = this.Topic_Title
            this.SubmitTopicBasedOnModule(Section)
        },
        SubmitTopicBasedOnModule(Section){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/addmoduletopic`,Section)
                        .then(response =>{
                            
                            this.$store.commit('SetCourseCurriculamList',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Added Section Successfully","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Section","Color":"green","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedCourseDetail   = {}
            this.SelectedModule         = {}
            this.Topic_Start_Time       = ""
            this.Topic_End_Time         = ""
            this.Topic_Title            = ''
        },
        GetCourseDetailsList(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        },
    }
}
</script>
<style scoped>

</style>